import { AccordionPlugin } from "./index.js";
export const RegisterPlugins = ({
  ...props
}) => {
  AccordionPlugin({
    ...props
  }); /*this is my custom component*/
};
export default RegisterPlugins;
//# sourceMappingURL=RegisterPlugins.js.map